// extracted by mini-css-extract-plugin
export var sliderRange = "_qf-2";
export var sliderRoot = "_qf-0";
export var sliderThumb = "_qf-3";
export var sliderTrack = "_qf-1";